module.exports = __webpack_public_path__ + "static/media/publish-videos-images-mobile-en.5c1cc373.png";